module.exports = __webpack_public_path__ + "img/kasparov.ed6e7870.png";